import styled from 'styled-components';
import { applyStyleModifiers } from 'styled-components-modifiers';

import { flex } from '../../../core';

const modifiers = {
  inline: () => ({
    styles: `
      ${flex('row', 'justify-content', 'center')};
      label {
        margin: 0 1rem 0 0;
        &:last-child {
          margin: 0;
        }
      }
    `,
  }),
};

export const FormCheckStyled = styled.div`
  label {
    margin: 0 0 .75rem;
    &:last-child {
      margin: 0;
    }
  }
  ${applyStyleModifiers(modifiers)};
`;
